(function() {
    'use strict';

    angular
        .module('elogbooks.user.meter-occupancies')
        .config(registerRoutes)
        .config(registerRoutesList)
        .config(registerRoutesAdd)
        .config(registerRoutesDetails)
        .config(registerRoutesEdit);

    function registerRoutes($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.occupancies', {
                abstract: true,
                template: '<bookerize></bookerize>',
                ncyBreadcrumb: {
                    skip: true
                },
                data: {
                    modules: ['meters']
                }
            });
    }

    function registerRoutesList($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.occupancies.list', {
                url: '/meter-occupancies?page&limit&order&id&name',
                parent: 'dashboard.user.meters.occupancies',
                views: parseBook({
                    'elogbooks-left@dashboard.user.meters.occupancies': {
                        templateUrl: '/modules/user/meters/meter-occupancies/meter-occupancies-list.html',
                        controller: 'MeterTypesController',
                        controllerAs: 'vm'
                    }
                }),
                params: {
                    page: '1',
                    limit: '30',
                    order: 'id',
                    id: null,
                    name: null
                },
                resolve: {
                    meterTypesCollectionResponse: function($stateParams, apiClient, rootResourceResponse) {
                        $stateParams.type = 'occupancy_type';

                        return apiClient.get(rootResourceResponse.getLink('metertypes'), $stateParams).then( function(response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"METER_OCCUPANCIES_LIST" | translate }}'
                }
            });
    }

    function registerRoutesAdd($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.occupancies.list.add', {
                url: '/add',
                parent: 'dashboard.user.meters.occupancies.list',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.occupancies': {
                        templateUrl: '/modules/user/meters/meter-occupancies/add-edit/meter-occupancies-add-edit.html',
                        controller: 'MeterTypesAddEditController',
                        controllerAs: 'vm'
                    }
                }),
                resolve: {
                    meterTypeResponse: function() {
                        return {
                            type : 'occupancy'
                        };
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"ADD" | translate }}'
                }
            });
    }

    function registerRoutesDetails($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.occupancies.list.details', {
                url: '/details/{resource}',
                abstract: true,
                parent: 'dashboard.user.meters.occupancies.list',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.occupancies': {
                        templateUrl: '/modules/user/meters/meter-occupancies/details/meter-occupancies-details.html',
                        controller: 'MeterTypesDetailsController',
                        controllerAs: 'vm'
                    }
                }),
                resolve: {
                    meterTypeResponse: function(apiClient, $stateParams) {
                        return apiClient.get($stateParams.resource.decode()).then( function(response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::$resolves().meterTypeResponse.name }}'
                }
            })
             .state('dashboard.user.meters.occupancies.list.details.info', {
                url: '/info',
                parent: 'dashboard.user.meters.occupancies.list.details',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.occupancies.list.details': {
                        templateUrl: '/modules/user/meters/meter-occupancies/details/info/meter-occupancies-info.html',
                        controller: 'MeterTypesInfoController',
                        controllerAs: 'vm'
                    }
                }),
                ncyBreadcrumb: {
                    label: '{{ ::"INFO" | translate }}'
                }
            });
    }

    function registerRoutesEdit($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.occupancies.list.details.info.edit', {
                url: '/edit',
                parent: 'dashboard.user.meters.occupancies.list.details.info',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.occupancies': {
                        templateUrl: '/modules/user/meters/meter-occupancies/add-edit/meter-occupancies-add-edit.html',
                        controller: 'MeterTypesAddEditController',
                        controllerAs: 'vm'
                    }
                }),
                ncyBreadcrumb: {
                    label: '{{ ::"EDIT" | translate }}'
                }
            });
    }

})();
